import SETTINGS from './config';
const modoVisualizacao = localStorage.getItem('modoVisualizacao');
const modoMapa = localStorage.getItem('modoMapa');
const restWP = `${SETTINGS.HOME}/wp-json/wp/v2`;
const restAeR = `${SETTINGS.HOME}/wp-json/conflitosurbanos/v1`;

const CONSTANTS = {
    HOME: SETTINGS.HOME,
    API: {
        busca: `${restAeR}/busca`,
        media: `${restWP}/media`,
        taxonomia: `${restWP}`,
        taxonomias: `${restAeR}/taxonomias`,
        iconesTemas: `${SETTINGS.HOME}/wp-content/themes/aer/images/temas`,
        sidebarMeta: `${restAeR}/sidebar_meta`,
    },
    MODO_MAPA: {
        MAPA: {
            id: 'MAPA',
            nome: 'Mapa',
            attrs: `<a href="${SETTINGS.HOME}">Despejo Zero</a> | &copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap contributors</a>`,
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
        },
        // SATELITE: {
        //     id: 'SATELITE',
        //     nome: 'Satélite',
        //     attrs: '&copy; <a href="https://mapbox.com">MapBox</a>',
        //     url: `https://api.mapbox.com/styles/v1/dtygel/ckmu0up7v17wt17panh3u8d5e/tiles/{z}/{x}/{y}?access_token=${SETTINGS.MAPBOX_ACCESS_TOKEN}`
        // }
    },
    LOCALSTORAGE: {
        modoVisualizacao: modoVisualizacao,
        modoMapa: modoMapa
    },
    TIPOS_DE_FICHA: [
        {
            id: 'conflito',
            slug: 'conflito',
            active: true,
            name: 'Dispositivo',
            plural: 'Dispositivos',
            cor: '#7774A2',
            searchFields: ['post_title'],
            searchMetaFields: ['descricao']
        },
        {
            id: 'organizacao',
            slug: 'organizacao',
            active: true,
            name: 'Organização',
            plural: 'Organizações',
            cor: '#63A5A3',
            searchFields: ['post_title'],
            searchMetaFields: ['descricao']
        },
        {
            id: 'experiencia',
            slug: 'experiencia',
            active: true,
            name: 'Experiência',
            plural: 'Experiências',
            cor: '#A4B65C',
            searchFields: ['post_title'],
            searchMetaFields: ['descricao']
        },
        {
            id: 'rede',
            slug: 'rede',
            active: true,
            name: 'Rede',
            plural: 'Redes',
            cor: '#FD9E4B',
            searchFields: ['post_title'],
            searchMetaFields: []
        }
    ],
    TAXONOMIAS_FILTROS: [
        {
            id: 'localizacao',
            slug: 'localizacao',
            label: 'Localização',
            // relatedTaxes: ['pais', 'mr', 'uf', 'bioma', 'bh1', 'bh2', 'municipio'],
            relatedTaxes: ['mr', 'uf', 'municipio'],
            placeholder: 'Localização',
            hint: 'Região, UF, Município, Bioma, Bacia Hidrográfica'
        },
        {
            id: 'status_conflito',
            slug: 'status_conflito',
            label: 'Situação Atual',
            placeholder: 'Situação Atual'
        },
        {
            id: 'causa_do_conflito',
            slug: 'causa_do_conflito',
            label: 'Causas do conflito',
            placeholder: 'Causas do conflito'
        },
        {
            id: 'numero_de_familias',
            slug: 'numero_de_familias',
            label: 'Número de Famílias',
            placeholder: 'Número de Famílias'
        },
        // {
        //     id: 'sujeito',
        //     slug: 'sujeito',
        //     label: 'Identidade',
        //     relatedTaxes: ['identidade', 'pct', 'indigena'],
        //     placeholder: 'Identidades'
        // },
        // {
        //     id: 'areas_tematicas',
        //     slug: 'areas_tematicas',
        //     label: 'Área temática',
        //     placeholder: 'Áreas temáticas'
        // },
        // {
        //     id: 'mapeamento',
        //     slug: 'mapeamento',
        //     label: 'Mapeamento',
        //     placeholder: 'Mapeamento(s)'
        // },
        // {
        //     id: 'abrangencia',
        //     slug: 'abrangencia',
        //     label: 'Abrangência',
        //     placeholder: 'Abrangência(s)',
        // }
    ],
    RECORTES_IDENTIDADE: {
        identidade: {
            id: 'identidade',
            nome: 'Identidade',
            plural: 'Identidades'
        },
        pct: {
            id: 'pct',
            nome: 'Povo ou Comunidade Tradicional',
            plural: 'Povos e Comunidades Tradicionais'
        },
        indigena: {
            id: 'indigena',
            nome: 'Povo Indígena',
            plural: 'Povos Indígenas'
        }
    },
    RECORTES_TERRITORIAIS: {
        // pais: {
        //     id: 'pais',
        //     nome: 'País',
        //     plural: 'Países',
        //     idField: 'CNTR_ID',
        //     nomeField: 'CNTR_NAME'
        // },
        mr: {
            id: 'mr',
            nome: 'Macrorregião',
            plural: 'Macrorregiões',
            idField: 'sigla',
            nomeField: 'nome'
        },
        uf: {
            id: 'uf',
            nome: 'Estado',
            plural: 'Estados',
            idField: 'SIGLA',
            nomeField: 'NOME_AC'
        },
        // bioma: {
        //     id: 'bioma',
        //     nome: 'Bioma',
        //     plural: 'Biomas',
        //     idField: 'BIO_NOMC',
        //     nomeField: 'BIO_NOM'
        // },
        // bh1: {
        //     id: 'bh1',
        //     nome: 'Bacia Hidrográfica de 1ª grandeza',
        //     plural: 'Bacias Hidrográficas de 1ª grandeza',
        //     idField: 'BH1_NOMC',
        //     nomeField: 'BH1_NOM'
        // }
    },
    SUB_RECORTES_TERRITORIAIS: {
        municipio: {
            id: "municipio",
            nome: "Município",
            plural: "Municípios",
            idField: "NM_MUNICIP",
            nomeField: "NM_MUNICIP",
            parentTax: "uf",
            parentIdField: "uf",
            filesPerParentPath: "municipio",
            idMask: "{idField} {parentIdField}",
            nomeMask: "{nomeField} {parentIdField}"
        },
        // bh2: {
        //     id: "bh2",
        //     nome: "Bacia Hidrográfica (2ª grandeza)",
        //     plural: "Bacias Hidrográficas de 2ª grandeza",
        //     idField: "BH2_NOME",
        //     nomeField: "BH2_NOME_C",
        //     parentTax: "bh1"
        // }
    },
    MAPA_THRESHOLD: {
        PTS: {
            mobile: 1000,
            desktop: 1500
        },
        RECORTE: 'mr'
    },
    FICHAS_PER_PAGE: {
        mobile: 6,
        desktop: 15
    },
    PALETA_DE_CORES_GRAFICOS: ['#FF5A0E', '#EE252C', '#882230', '#58C034', '#69A056', '#6052B2'],
    PALETA_DE_CORES: ['#3366cc',  '#dc3912',  '#ff9900',  '#109618',  '#990099',  '#0099c6',  '#dd4477',  '#66aa00',  '#b82e2e',  '#316395',  '#3366cc',  '#994499',  '#22aa99',  '#aaaa11',  '#6633cc',  '#e67300',  '#8b0707',  '#651067',  '#329262',  '#5574a6',  '#3b3eac',  '#b77322',  '#16d620',  '#b91383',  '#f4359e',  '#9c5935',  '#a9c413',  '#2a778d',  '#668d1c',  '#bea413',  '#0c5922',  '#743411'],
    PALETA_DE_CORES_2: [
      '#FEBDC4',
      '#31DABF',
      '#98C647',
      '#63A5A3',
      '#78A42A',
      '#843F7E',
      '#D74D5B',
      '#FECC60',
      '#FD9E4B',
      '#996CFB',
    ],
    MACRORREGIOES_CEM: {
        NO: [],
        N: [],
        NE: [],
        CO: [],
        SEE: [],
        S: []
    },
    MACRORREGIOES: {
        N: ['ac', 'ap', 'am', 'pa', 'ro', 'rr', 'to'],
        NE: ['al', 'ba', 'ce', 'ma', 'pb', 'pe', 'pi', 'rn', 'se'],
        CO: ['go', 'mt', 'ms', 'df'],
        SEE: ['es', 'mg', 'rj', 'sp'],
        S: ['pr', 'sc', 'rs']
    },
    INTERVALO_STEPS: {
        'mobile': 5,
        'desktop': 12
    },
    MOBILE_BREAKPOINT: 992,
    ICON_SIZE_BREAKPOINTS: {
        'mr': [10000, 50000],
        'uf': [1000, 20000],
        'municipio': [100, 1000],
    },
    FAMILIAS_PESSOAS: {
        pessoas_por_familia: 4,
        idosos_por_pessoas: 0.168,
        criancas_por_pessoas: 0.171,
        mulheres_por_pessoas: 0.6,
        negras_por_pessoas: 0.66,
    },
};


CONSTANTS.emptyFilters = {
    modo: modoVisualizacao ? modoVisualizacao : 'panorama',
    tipoGroup: CONSTANTS.TIPOS_DE_FICHA,
    intervaloDataValue: [],
    q: '',
    recorteTerritorial: 'mr'
};
for (let tax of CONSTANTS.TAXONOMIAS_FILTROS) {
    CONSTANTS.emptyFilters[tax.id] = [];
}

export default CONSTANTS;
